<template>
  <v-card min-height="550">
    <!-- <v-dialog v-model="editDialog" transition="dialog-top-transition" max-width="500">
                    <template>
                        <v-card rounded="0">
                            <v-toolbar color="secondary" class="white--text">
                                <v-toolbar-title class="font-weight-bold">
                                    Warning
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon class="white--text" @click="closeEditConfirmation">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text class="black--text pt-5 text-center" style="font-size: 20px">
                                <span>
                                    Are you sure ?
                                </span>
                            </v-card-text>
                            <v-card-text class="black--text text-center" style="font-size: 14px">
                                Do you really want to edit this record ?
                                <p> Your previous records might get affected.
                                </p>
                            </v-card-text>
                            <div class="mx-4">
                                <v-divider></v-divider>
                            </div>
                            <v-card-actions class="px-4 py-5 justify-center">
                                <div>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="closeEditConfirmation" outlined class="mr-2 px-5" right height="44" depressed
                                        color="primary" style="font-weight: 600;">
                                        Cancel
                                    </v-btn>
                                    <v-btn @click="startEdit(currentEditItem)" right height="44" color="success" style="font-weight: 600;"
                                        class="px-5 btn-11 btn-22">
                                        Edit
                                    </v-btn>
                                </div>
                            </v-card-actions>
                        </v-card>
                    </template>
                </v-dialog> -->
    <v-dialog
      v-model="deleteWarningDialog"
      transition="dialog-top-transition"
      max-width="500"
    >
      <template>
        <v-card rounded="0">
          <v-toolbar color="secondary" class="white--text">
            <v-toolbar-title class="font-weight-bold">
              Warning
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon class="white--text" @click="closeDeleteWarningDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text
            class="black--text pt-5 text-center"
            style="font-size: 20px"
          >
            <span> Are you sure ? </span>
          </v-card-text>
          <v-card-text class="black--text text-center" style="font-size: 14px">
            Do you really want to delete this record ?
            <p class="mb-0">This process cannot be undone.</p>
          </v-card-text>
          <div class="mx-4">
            <v-divider></v-divider>
          </div>
          <v-card-actions class="px-4 py-5 justify-center">
            <div>
              <v-spacer></v-spacer>
              <v-btn
                @click="closeDeleteWarningDialog"
                outlined
                class="mr-2 px-5"
                right
                height="44"
                depressed
                color="primary"
                style="font-weight: 600"
              >
                 {{ $t("cancel") }}
              </v-btn>
              <v-btn
                @click="deleteRecord"
                right
                height="44"
                color="error"
                class="px-5"
                style="font-weight: 600"
              >
                Delete
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <v-dialog v-model="treatmentDialog" max-width="650">
      <v-form
        ref="treatmentForm"
        v-model="treatmentValid"
        lazy-validation
        @submit.prevent="submitTreatment"
      >
        <v-card class="custom-card" rounded="0">
          <v-toolbar color="secondary" dark class="text-h6">
            <div v-if="isEdit && tableEdit">Update Treatment</div>
            <div v-else-if="isEdit">Update Treatment</div>
            <div v-else>Add New Treatment</div>
            <v-spacer></v-spacer>
            <v-btn icon class="white--text" @click="closeTreatmentDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <!-- <v-card-text>
               asdasd
            </v-card-text> -->
          <div class="px-5 py-5">
            <v-row>
              <v-col cols="12" v-if="isEdit">
                <v-card flat color="transparent">
                  <v-toolbar
                    class="bdr secondary2light"
                    :elevation="0"
                    outlined
                  >
                    <v-toolbar-title
                      class="grey--text text--darken-2"
                      style="font-size: 13px"
                    >
                      Do you really want to edit this record ? Your previous
                      records might get affected.
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </v-card>
              </v-col>
              <v-col class="py-0" sm="6">
                <label class="label"
                  >{{ $t("animal.healthRecordInfo.treatment") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{ $t("animal.treatment.tooltip.treatment") }}
                    </span>
                  </v-tooltip></label
                >
                <v-text-field
                  outlined
                  placeholder="Enter Treatment Name"
                  dense
                  v-model="treatmentData.treatment_name"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" sm="3">
                <label class="label"
                  >{{ $t("animal.healthRecordInfo.doseRate") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{ $t("animal.healthRecordInfo.dooseTooltip") }}
                    </span>
                  </v-tooltip></label
                >
                <v-text-field
                  outlined
                  placeholder="Enter Value"
                  dense
                  type="number"
                  :min="0"
                  oninput="this.value = Math.abs(this.value)"
                  v-model="treatmentData.dose_rate"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" sm="3">
                <label class="label"> {{ "." }}</label>
                <v-select
                  outlined
                  placeholder="Select Units"
                  dense
                  v-model="treatmentData.dose_rate_unit"
                  :items="doseRateUnitOptions"
                ></v-select>
              </v-col>
              <!-- <v-col class="py-0" sm="6">
                <label class="label"
                  >{{ $t("animal.healthRecordInfo.treatmentReason") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{ $t("animal.treatment.tooltip.treatmentReason") }}
                    </span>
                  </v-tooltip></label
                >
                <v-text-field
                  outlined
                  placeholder="Enter Treatment Reason"
                  dense
                  v-model="treatmentData.reason_of_treatment"
                ></v-text-field>
              </v-col> -->
            </v-row>
            <v-row>
              <v-col class="py-0" sm="6">
                <label class="label"
                  >{{ $t("animal.healthRecordInfo.treatmentDate") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{ $t("animal.treatment.tooltip.treatmentDate") }}
                    </span>
                  </v-tooltip></label
                >
                <v-menu
                  v-model="treatmentDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="treatmentData.treatment_date"
                      append-icon="mdi-calendar"
                      outlined
                      dense
                      readonly
                      placeholder="Select Date"
                      v-bind="attrs"
                      v-on="on"
                      v-on:click:append="treatmentDateMenu = true"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :max="nowDate"
                    v-model="treatmentData.treatment_date"
                    @input="treatmentDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="py-0" sm="6">
                <label class="label"
                  >{{ $t("animal.healthRecordInfo.diagnosis") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{ $t("animal.treatment.tooltip.diagnosis") }}
                    </span>
                  </v-tooltip></label
                >
                <v-text-field
                  outlined
                  placeholder="Enter Name of Diagnosis"
                  dense
                  v-model="treatmentData.name_of_diagnosis"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" sm="6">
                <label class="label"
                  >{{ $t("animal.healthRecordInfo.drugID") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{ $t("animal.treatment.tooltip.drugId") }}
                    </span>
                  </v-tooltip></label
                >
                <v-text-field
                  outlined
                  placeholder="Enter Drug ID"
                  dense
                  v-model="treatmentData.drug_id"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" sm="6">
                <label class="label"
                  >{{ $t("animal.healthRecordInfo.drugName") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{ $t("animal.treatment.tooltip.drugName") }}
                    </span>
                  </v-tooltip></label
                >
                <v-text-field
                  outlined
                  placeholder="Enter Name of the Drug"
                  dense
                  v-model="treatmentData.treatment_drug_name"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" sm="3">
                <label class="label"
                  >{{ $t("animal.healthRecordInfo.drugWithdrawalperiod") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{ $t("animal.treatment.tooltip.drugWithDrawalPeriod") }}
                    </span>
                  </v-tooltip></label
                >
                <v-text-field
                  outlined
                  placeholder="Enter Value"
                  dense
                  type="number"
                  :min="0"
                  oninput="this.value = Math.abs(this.value)"
                  v-model="treatmentData.drug_withdrawal_period"
                ></v-text-field>
              </v-col>
              <v-col class="py-0" sm="3">
                <label class="label"> {{ "." }}</label>
                <v-select
                  outlined
                  placeholder="Select Units"
                  dense
                  v-model="treatmentData.drug_withdrawal_period_unit"
                  :items="withdrawPeriodUnitsOptions"
                ></v-select>
              </v-col>
              <v-col class="py-0" sm="6">
                <label class="label"
                  >{{ $t("animal.healthRecordInfo.attendingVeterinarian") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{ $t("animal.treatment.tooltip.veterinarianName") }}
                    </span>
                  </v-tooltip></label
                >
                <v-text-field
                  outlined
                  placeholder="Veterinarian Name"
                  dense
                  v-model="treatmentData.attending_vetenarian"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" sm="6">
                <label class="label"
                  >{{ $t("animal.healthRecordInfo.packId") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{ $t("animal.treatment.tooltip.packId") }}
                    </span>
                  </v-tooltip></label
                >
                <v-text-field
                  outlined
                  placeholder="Enter Pack ID"
                  dense
                  v-model="treatmentData.pack_id"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <v-divider></v-divider>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              outlined
              @click="closeTreatmentDialog"
            >
               {{ $t("cancel") }}
            </v-btn>

            <v-btn depressed color="primary" type="submit">
              <span v-if="isEdit">{{ $t("update") }}</span>
              <span v-else>{{ $t("submit") }}</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="prognosisDialog" max-width="600">
      <v-form
        ref="prognosisForm"
        v-model="prognosisValid"
        lazy-validation
        @submit.prevent="submitPrognosis"
      >
        <v-card class="custom-card" rounded="0">
          <v-toolbar color="secondary" dark class="text-h6">
            <div v-if="isEdit && tableEdit">
              Update Prognosis
              <v-tooltip top color="black">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="red" v-bind="attrs" v-on="on">
                    mdi-help-circle-outline
                  </v-icon>
                </template>
                <span>{{
                  ` Do you really want to edit this record ? Your previous records might get affected.`
                }}</span>
              </v-tooltip>
            </div>
            <div v-else-if="isEdit">Update Prognosis</div>
            <div v-else>Add New Prognosis</div>
            <v-spacer></v-spacer>
            <v-btn icon class="white--text" @click="closePrognosisDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <div class="px-5 py-5">
            <v-row>
              <v-col class="py-0" sm="6">
                <label class="label">{{
                  $t("animal.healthRecordInfo.treatmentStartDate")
                }}
                     <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{$t('The date on which a medical treatment was administered to an animal. This can be the start date of a course of treatment or the date of a single treatment')}}</span>
                  </v-tooltip>  
              </label>
                <v-menu
                  v-model="prognosisStartMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="prognosisData.treatment_start_date"
                      append-icon="mdi-calendar"
                      outlined
                      dense
                      readonly
                      placeholder="Select Date"
                      v-bind="attrs"
                      v-on="on"
                      v-on:click:append="prognosisStartMenu = true"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="prognosisData.treatment_start_date"
                    @input="prognosisStartMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="py-0" sm="6">
                <label class="label">{{
                  $t("animal.healthRecordInfo.treatmentEndDate")
                }}

<v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{$t('The date on which a medical treatment is scheduled to be completed. This can be the date of the last treatment in a course of treatment, the date on which the animal is expected to be cured or to have their condition under control.')}}</span>
                  </v-tooltip>
              
              
              </label>
                <v-menu
                  v-model="prognosisEndMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="prognosisData.treatment_end_date"
                      append-icon="mdi-calendar"
                      outlined
                      dense
                      readonly
                      placeholder="Select Date"
                      v-bind="attrs"
                      v-on="on"
                      v-on:click:append="prognosisEndMenu = true"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="prognosisData.treatment_end_date"
                    @input="prognosisEndMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="py-0" sm="6">
                <label class="label">{{
                  $t("animal.healthRecordInfo.prognosis")
                }}
              <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{$t('animal.healthRecordInfo.prognosisDetail')}}
                    </span>
                  </v-tooltip>  
              </label>
                <v-text-field
                  outlined
                  placeholder="Enter Prognosis"
                  dense
                  v-model="prognosisData.prognosis"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>
          <v-divider></v-divider>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              outlined
              @click="closePrognosisDialog"
            >
              Cancel
            </v-btn>
            <v-btn depressed color="primary" type="submit"> Submit </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <div class="d-flex mb-4">
      <h2>Treatment</h2>
      <v-spacer></v-spacer>
      <div>
        <v-btn
          height="50"
          width="300"
          color="primary"
          outlined
          @click="startEdit(panel == 0 ? currentTreatment : currentPrognosis)"
          v-show="!disableCurrentRecordButton"
          >EDIT CURRENT
          {{ panel == 0 ? "TREATMENT" : "PROGNOSIS" }} RECORD</v-btn
        >
      </div>
      <div class="ml-5">
        <div class="d-flex justify-end">
          <v-btn
            height="50"
            width="250"
            @click="startCreate"
            dense
            depressed
            color="primary"
            :disabled="panel == undefined"
            >ADD NEW {{ panel == 0 ? "TREATMENT" : "PROGNOSIS" }} RECORD</v-btn
          >
        </div>
      </div>
    </div>

    <v-row justify="center">
      <v-expansion-panels
        class="mt-5"
        style="max-width: 97.5%"
        flat
        v-model="panel"
      >
        <v-expansion-panel>
          <v-expansion-panel-header class="subtitle-1">
            <span>Treatment Details</span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row width="100%">
              <v-col cols="12" md="4">
                <v-card class="pa-2 green2 elevation-0">
                  <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
                  <v-list class="green2">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >{{ $t("animal.healthRecordInfo.treatment") }}
                          <v-tooltip top color="black">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              $t("animal.healthRecordInfo.treatmentDetail")
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-list-item-title class="text-h6 mt-2">
                          {{
                            currentTreatment && currentTreatment.treatment_name
                              ? currentTreatment.treatment_name
                              : "Not Specified"
                          }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 green2 elevation-0">
                  <v-list class="green2">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >{{ $t("animal.healthRecordInfo.doseRate") }}
                          <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              $t(
                                "animal.healthRecordInfo.dose"
                              )
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-list-item-title class="text-h6 mt-2">
                          {{
                            currentTreatment &&
                            currentTreatment.dose_rate
                              ? `${currentTreatment.dose_rate} ${currentTreatment.dose_rate_unit}`
                              : "Not Specified"
                          }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
              <!-- <v-col cols="12" md="4">
                <v-card class="pa-2 green2 elevation-0">
                  <v-list class="green2">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >{{ $t("animal.healthRecordInfo.reasonTreatment") }}
                          <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              $t(
                                "animal.healthRecordInfo.reasonOfTreatmentDetail"
                              )
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-list-item-title class="text-h6 mt-2">
                          {{
                            currentTreatment &&
                            currentTreatment.reason_of_treatment
                              ? currentTreatment.reason_of_treatment
                              : "Not Specified"
                          }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col> -->

              <v-col cols="12" md="4">
                <v-card class="pa-2 green2 elevation-0">
                  <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
                  <v-list class="green2">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >{{ $t("animal.healthRecordInfo.treatmentDate") }}
                          <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              $t("animal.healthRecordInfo.treatmentDateDetail")
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-list-item-title class="text-h6 mt-2">
                          {{
                            currentTreatment && currentTreatment.treatment_date
                              ? formatDate(currentTreatment.treatment_date)
                              : "Not Specified"
                          }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 green2 elevation-0">
                  <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
                  <v-list class="green2">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >{{ $t("animal.healthRecordInfo.diagnosis") }}
                          <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              $t("animal.healthRecordInfo.diagnosisDetail")
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-list-item-title class="text-h6 mt-2">
                          {{
                            currentTreatment &&
                            currentTreatment.name_of_diagnosis
                              ? currentTreatment.name_of_diagnosis
                              : "Not Specified"
                          }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 green2 elevation-0">
                  <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
                  <v-list class="green2">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >{{ $t("animal.healthRecordInfo.drugID") }}
                          <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              $t("animal.healthRecordInfo.drugIDDetail")
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-list-item-title class="text-h6 mt-2">
                          {{
                            currentTreatment && currentTreatment.drug_id
                              ? currentTreatment.drug_id
                              : "Not Specified"
                          }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 green2 elevation-0">
                  <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
                  <v-list class="green2">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >{{ $t("animal.healthRecordInfo.drugName") }}
                          <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              $t("animal.healthRecordInfo.drugNameDetail")
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-list-item-title class="text-h6 mt-2">
                          {{
                            currentTreatment &&
                            currentTreatment.treatment_drug_name
                              ? currentTreatment.treatment_drug_name
                              : "Not Specified"
                          }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 green2 elevation-0">
                  <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
                  <v-list class="green2">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >{{
                            $t("animal.healthRecordInfo.drugWithdrawalperiod")
                          }}
                          <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              $t(
                                "animal.healthRecordInfo.drugWithdrawalperiodDetail"
                              )
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-list-item-title class="text-h6 mt-2">
                          {{
                            currentTreatment &&
                            currentTreatment.drug_withdrawal_period
                              ? getDrugWithDrawalPeriod(currentTreatment)
                              : "Not Specified"
                          }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 green2 elevation-0">
                  <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
                  <v-list class="green2">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >{{
                            $t("animal.healthRecordInfo.attendingVeterinarian")
                          }}
                          <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              $t(
                                "animal.healthRecordInfo.attendingVeterinarianDetail"
                              )
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-list-item-title class="text-h6 mt-2">
                          {{
                            currentTreatment &&
                            currentTreatment.attending_vetenarian
                              ? currentTreatment.attending_vetenarian
                              : "Not Specified"
                          }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 green2 elevation-0">
                  <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
                  <v-list class="green2">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >{{ $t("animal.healthRecordInfo.packId") }}
                          <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              $t("animal.healthRecordInfo.packIdDetail")
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-list-item-title class="text-h6 mt-2">
                          {{
                            currentTreatment && currentTreatment.pack_id
                              ? currentTreatment.pack_id
                              : "Not Specified"
                          }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>
            <div>
              <label class="mt-5"> Treatment History</label>
              <v-data-table
                class="mt-5 rounded-xl"
                :headers="treatmentHeaders"
                :items="findAllTreatment.slice(1)"
                :items-per-page="20"
                hide-default-footer
                :loading="loading"
                loading-text="Loading Data..."
              >
                <template v-slot:item.treatment_date="{ item }">
                  <div>
                    {{
                      (typeof item.treatment_date == "string" &&
                        item.treatment_date.split("T")[0]) ||
                      ""
                    }}
                  </div>
                </template>
                <template v-slot:item.dose_rate="{ item }">
                  <div>
                    {{ `${item.dose_rate} ${item.dose_rate_unit}` }}
                  </div>
                </template>
                <template v-slot:item.drug_withdrawal_period="{ item }">
                  <div>
                    {{
                      item.drug_withdrawal_period &&
                      getDrugWithDrawalPeriod(item)
                    }}
                  </div>
                </template>
                <template v-slot:item.action="{ item }">
                  <div>
                    <v-row>
                      <v-col sm="6">
                        <v-icon
                          dark
                          color="gray"
                          @click="
                            startEdit(item);
                            tableEdit = true;
                          "
                        >
                          mdi-pencil
                        </v-icon>
                      </v-col>
                      <v-col sm="6">
                        <v-icon dark color="red" @click="startDelete(item)">
                          mdi-delete
                        </v-icon>
                      </v-col>
                    </v-row>
                  </div>
                </template>
                <template v-slot:footer></template>
              </v-data-table>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="subtitle-1">
            <span>Prognosis</span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row width="100%">
              <v-col cols="12" md="4">
                <v-card class="pa-2 green2 elevation-0">
                  <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
                  <v-list class="green2">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >{{
                            $t("animal.healthRecordInfo.treatmentStartDate")
                          }}
                          <v-tooltip top color="black">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              $t("animal.healthRecordInfo.treatmentStartDate")
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-list-item-title class="text-h6 mt-2">
                          {{
                            currentPrognosis &&
                            currentPrognosis.treatment_start_date
                              ? formatDate(
                                  currentPrognosis.treatment_start_date
                                )
                              : "Not Specified"
                          }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 green2 elevation-0">
                  <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
                  <v-list class="green2">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >{{ $t("animal.healthRecordInfo.treatmentEndDate") }}
                          <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              $t("animal.healthRecordInfo.treatmentEndDate")
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-list-item-title class="text-h6 mt-2">
                          {{
                            currentPrognosis &&
                            currentPrognosis.treatment_end_date
                              ? formatDate(currentPrognosis.treatment_end_date)
                              : "Not Specified"
                          }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>

              <v-col cols="12" md="4">
                <v-card class="pa-2 green2 elevation-0">
                  <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
                  <v-list class="green2">
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          >{{ $t("animal.healthRecordInfo.prognosis") }}
                          <v-tooltip top color="black" max-width="350">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on">
                                mdi-help-circle-outline
                              </v-icon>
                            </template>
                            <span>{{
                              $t("animal.healthRecordInfo.prognosisDetail")
                            }}</span>
                          </v-tooltip>
                        </v-list-item-subtitle>
                        <v-list-item-title class="text-h6 mt-2">
                          {{
                            currentPrognosis && currentPrognosis.prognosis
                              ? currentPrognosis.prognosis
                              : "Not Specified"
                          }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>
            <div>
              <label class="mt-5"> Prognosis History</label>
              <v-data-table
                class="mt-5 rounded-xl"
                :headers="prognosisHeaders"
                :items="findAllPrognosis.slice(1)"
                :items-per-page="20"
                hide-default-footer
                :loading="loading"
                loading-text="Loading Data..."
              >
                <template v-slot:item.treatment_start_date="{ item }">
                  <div>
                    {{
                      (typeof item.treatment_start_date == "string" &&
                        item.treatment_start_date.split("T")[0]) ||
                      ""
                    }}
                  </div>
                </template>
                <template v-slot:item.treatment_end_date="{ item }">
                  <div>
                    {{
                      (typeof item.treatment_end_date == "string" &&
                        item.treatment_end_date.split("T")[0]) ||
                      ""
                    }}
                  </div>
                </template>

                <template v-slot:item.action="{ item }">
                  <div>
                    <v-row>
                      <v-col sm="6">
                        <v-icon
                          dark
                          color="gray"
                          @click="
                            startEdit(item);
                            tableEdit = true;
                          "
                        >
                          mdi-pencil
                        </v-icon>
                      </v-col>
                      <v-col sm="6">
                        <v-icon dark color="red" @click="startDelete(item)">
                          mdi-delete
                        </v-icon>
                      </v-col>
                    </v-row>
                  </div>
                </template>
                <template v-slot:footer></template>
              </v-data-table>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
import loading from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";
import gql from "graphql-tag";

export default {
  apollo: {
    findAllTreatment: {
      query: gql`
        query findAllTreatment($animalId: Float!) {
          findAllTreatment(animalId: $animalId) {
            id
            treatment_name
            dose_rate
            dose_rate_unit
            reason_of_treatment
            treatment_date
            name_of_diagnosis
            treatment_drug_name
            drug_withdrawal_period
            drug_withdrawal_period_unit
            attending_vetenarian
            drug_id
            pack_id
          }
        }
      `,
      variables() {
        return {
          animalId: Number(this.$route.params.animal_number),
        };
      },
      result: function ({ data }) {
        if (data) {
          this.currentTreatment = data.findAllTreatment[0] || null;
        }
      },
      update: (data) => {
        return data.findAllTreatment;
      },
    },
    findAllPrognosis: {
      query: gql`
        query findAllPrognosis($animalId: Float!) {
          findAllPrognosis(animalId: $animalId) {
            id
            treatment_start_date
            treatment_end_date
            prognosis
          }
        }
      `,
      variables() {
        return {
          animalId: Number(this.$route.params.animal_number),
        };
      },
      result: function ({ data }) {
        if (data) {
          this.currentPrognosis = data.findAllPrognosis[0] || null;
        }
      },
      update: (data) => {
        return data.findAllPrognosis;
      },
    },
  },
  created() {
    console.log("treatment");
  },
  mixins: [generalMixin, loading],
  data() {
    return {
      loading: false,
      tableEdit: false,
      currentEditItem: null,
      editDialog: false,
      prognosisValid: false,
      prognosisStartMenu: false,
      prognosisEndMenu: false,
      prognosisData: {},
      prognosisDialog: false,
      nowDate: new Date().toISOString().slice(0, 10),
      deleteWarningDialog: false,
      currentTreatment: null,
      currentPrognosis: null,
      treatmentHeaders: [
        {
          text: "Treatment Name",
          align: "start",
          sortable: true,
          value: "treatment_name",
        },
        {
          text: "Dose Rate",
          align: "start",
          sortable: true,
          value: "dose_rate",
        },
        // {
        //   text: "Treatment Reason",
        //   align: "start",
        //   sortable: true,
        //   value: "reason_of_treatment",
        // },
        {
          text: "Treatment Date",
          align: "start",
          sortable: true,
          value: "treatment_date",
        },
        {
          text: "Diagnosis",
          align: "start",
          sortable: true,
          value: "name_of_diagnosis",
        },
        {
          text: "Drug ID",
          align: "start",
          sortable: true,
          value: "drug_id",
        },
        {
          text: "Drug Name",
          align: "start",
          sortable: true,
          value: "treatment_drug_name",
        },
        {
          text: "Drug Withdrawal Period",
          align: "start",
          sortable: true,
          value: "drug_withdrawal_period",
        },
        {
          text: "",
          align: "start",
          sortable: true,
          value: "action",
        },
      ],
      prognosisHeaders: [
        {
          text: "Treatment Starting Date",
          align: "start",
          sortable: true,
          value: "treatment_start_date",
        },
        {
          text: "Treatment Ending Date",
          align: "start",
          sortable: true,
          value: "treatment_end_date",
        },
        {
          text: "Prognosis",
          align: "start",
          sortable: true,
          value: "prognosis",
        },
        {
          text: "",
          align: "start",
          sortable: true,
          value: "action",
        },
      ],
      findAllTreatment: [],
      treatmentDateMenu: false,
      treatmentValid: false,
      withdrawPeriodUnitsOptions: [
        { text: "Hour(s)", value: "1" },
        { text: "Day(s)", value: "2" },
        { text: "Week(s)", value: "3" },
      ],
      doseRateUnitOptions: [
        "mg",
        "gm",
        "kg"
      ],
      treatmentData: {
        drug_withdrawal_period_unit: "",
      },
      treatmentDialog: false,
      panel: 0,
      isEdit: false,
      treatmentRules: {
        drugWithdrawalperiod: [
          (v) => {
            if (v) return v >= 0 || "Value cannot be less than 0";
          },
        ],
      },
    };
  },
  methods: {
    closeEditConfirmation() {
      this.editDialog = false;
    },
    getDrugWithDrawalPeriod(item) {
      if (item?.drug_withdrawal_period_unit) {
        const period = this.withdrawPeriodUnitsOptions.find(
          (data) => data.value == item.drug_withdrawal_period_unit
        );

        return `${item.drug_withdrawal_period} ${period?.text}`;
      }

      return item.drug_withdrawal_period;
    },
    async deleteRecord() {
      if (this.panel == 0) {
        let formData = {};
        formData = this.treatmentData;
        this.startLoading();
        try {
          delete formData.__typename;
          await this.$apollo
            .mutate({
              mutation: gql`
                mutation deleteHealthTreatment(
                  $data: UpdateHealthTreatmentInput!
                ) {
                  deleteHealthTreatment(updateHealthTreatmentInput: $data)
                }
              `,
              variables: {
                data: formData,
              },
            })
            .then(async (response) => {
              this.$notify({
                title: `History deleted successfully`,
                text: response.message,
                type: "success",
                position: "top right",
              });
            });
          this.closeTreatmentDialog();
          this.$apollo.queries.findAllTreatment.refetch();
          this.currentTreatment = await this.findAllTreatment[0];
          // this.$notify({
          //   title: `Treatment Record Deleted Successfully`,

          //   type: "error",
          //   position: "top right",
          // });
        } catch (error) {
          this.stopLoading();
          this.closeDeleteWarningDialog();
        }
        this.stopLoading();
        this.closeDeleteWarningDialog();
      } else {
        let formData = {};
        formData = this.prognosisData;
        this.startLoading();
        try {
          delete formData.__typename;
          await this.$apollo.mutate({
            mutation: gql`
              mutation deletePrognosis($data: UpdatePrognosisInput!) {
                deletePrognosis(updatePrognosisInput: $data)
              }
            `,
            variables: {
              data: formData,
            },
          });
          this.closePrognosisDialog();
          this.$apollo.queries.findAllPrognosis.refetch();
          this.currentPrognosis = await this.findAllPrognosis[0];
          this.$notify({
            title: `Prognosis Record Deleted Successfully`,

            type: "error",
            position: "top right",
          });
        } catch (error) {
          this.stopLoading();
          this.closeDeleteWarningDialog();
        }
        this.stopLoading();
        this.closeDeleteWarningDialog();
      }
    },
    startEdit(item) {
      this.editDialog = false;
      if (this.panel == 0) {
        (this.isEdit = true),
          (this.treatmentData = item || this.findAllTreatment[0]);
        this.treatmentData.treatment_date =
          this.treatmentData.treatment_date &&
          this.treatmentData.treatment_date.split("T")[0];
        this.treatmentDialog = true;
      } else {
        (this.isEdit = true),
          (this.prognosisData = item || this.findAllPrognosis[0]);
        this.prognosisData.treatment_start_date =
          this.prognosisData.treatment_start_date &&
          this.prognosisData.treatment_start_date.split("T")[0];
        this.prognosisData.treatment_end_date =
          this.prognosisData.treatment_end_date &&
          this.prognosisData.treatment_end_date.split("T")[0];
        this.prognosisDialog = true;
      }
    },
    closeDeleteWarningDialog() {
      this.deleteWarningDialog = false;
      this.treatmentData = {
        drug_withdrawal_period_unit: "",
      };
    },
    startDelete(item) {
      if (this.panel == 0) {
        this.treatmentData = item;
        this.deleteWarningDialog = true;
      } else {
        this.prognosisData = item;
        this.deleteWarningDialog = true;
      }
    },
    startCreate() {
      if (this.panel == 0) {
        this.isEdit = false;
        this.treatmentData = {
          drug_withdrawal_period_unit: "",
        };
        this.treatmentDialog = true;
      } else if (this.panel == 1) {
        this.isEdit = false;
        this.prognosisData = {};
        this.prognosisDialog = true;
      }
    },
    closeTreatmentDialog() {
      this.treatmentDialog = false;
      this.treatmentData = {
        drug_withdrawal_period_unit: "",
      };
    },
    closePrognosisDialog() {
      this.prognosisDialog = false;
      this.prognosisData = {};
    },
    async submitTreatment() {
      //console.log(this.treatmentData,"this.treatmentData;this.treatmentData",Object.keys(this.treatmentData).length);
      //  return;

      if (Object.keys(this.treatmentData).length == 1) {
        this.$notify({
          //title: `No details entered.`,
          text: "No details entered.",
          type: "error",
          position: "top right",
        });
        return;
      }

      let formData = {};
      formData = this.treatmentData;
      formData.dose_rate = Number(formData.dose_rate);
      formData.animalId = Number(this.$route.params.animal_number);
      formData.drug_withdrawal_period = Number(formData.drug_withdrawal_period);
      this.startLoading();
      if (this.isEdit) {
        try {
          delete formData.__typename;
          await this.$apollo.mutate({
            mutation: gql`
              mutation updateHealthTreatment(
                $data: UpdateHealthTreatmentInput!
              ) {
                updateHealthTreatment(updateHealthTreatmentInput: $data)
              }
            `,
            variables: {
              data: formData,
            },
          });
          this.closeTreatmentDialog();
          this.$notify({
            title: `Treatment Updated  Successfully`,

            type: "success",
            position: "top right",
          });
        } catch (error) {
          this.stopLoading();
          this.closeTreatmentDialog();
        }
      } else {
        try {
          await this.$apollo.mutate({
            // Query
            mutation: gql`
              mutation ($data: CreateHealthTreatmentInput!) {
                createHealthTreatment(CreateHealthTreatmentInput: $data) {
                  id
                }
              }
            `,
            // Parameters
            variables: {
              data: formData,
            },
          });
          this.closeTreatmentDialog();
          this.$apollo.queries.findAllTreatment.refetch();
          this.currentTreatment = await this.findAllTreatment[0];
          this.$notify({
            title: `Treatment Added Successfully`,

            type: "success",
            position: "top right",
          });
        } catch (error) {
          this.stopLoading();
          this.closeTreatmentDialog();
        }
      }

      this.stopLoading();
    },
    async submitPrognosis() {
      if (Object.keys(this.prognosisData).length == 0) {
        this.$notify({
          //title: `No details entered.`,
          text: "No details entered.",
          type: "error",
          position: "top right",
        });
        return;
      }

      let formData = {};

      formData = this.prognosisData;
      formData.animalId = Number(this.$route.params.animal_number);
      this.startLoading();
      if (this.isEdit) {
        try {
          delete formData.__typename;
          await this.$apollo.mutate({
            mutation: gql`
              mutation updatePrognosis($data: UpdatePrognosisInput!) {
                updatePrognosis(updatePrognosisInput: $data)
              }
            `,
            variables: {
              data: formData,
            },
          });
          this.closePrognosisDialog();
          this.$notify({
            title: `Prognosis Updated  Successfully`,

            type: "success",
            position: "top right",
          });
        } catch (error) {
          this.stopLoading();
          this.closePrognosisDialog();
        }
      } else {
        try {
          await this.$apollo.mutate({
            // Query
            mutation: gql`
              mutation ($data: CreatePrognosisInput!) {
                createPrognosis(CreatePrognosisInput: $data) {
                  id
                }
              }
            `,
            // Parameters
            variables: {
              data: formData,
            },
          });
          this.closePrognosisDialog();
          this.$apollo.queries.findAllPrognosis.refetch();
          this.currentPrognosis = await this.findAllPrognosis[0];
          this.$notify({
            title: `Prognosis Created  Successfully`,

            type: "success",
            position: "top right",
          });
        } catch (error) {
          this.stopLoading();
          this.closePrognosisDialog();
        }
      }

      this.stopLoading();
    },
  },
  computed: {
    ...mapGetters([""]),
    disableCurrentRecordButton() {
      if (this.panel == undefined) {
        return true;
      } else if (this.panel == 0 && !this.currentTreatment) {
        return true;
      } else if (this.panel == 1 && !this.currentPrognosis) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.panel = 0;
  },
  watch: {
    refreshProp() {
      this.panel = 0;
    },
  },
  props: ["treatment", "refreshProp"],
};
</script>

<style lang="scss" scoped>
.v-expansion-panel {
  margin-top: 10px;
}
.v-expansion-panel-header {
  background: #f3f3f380;
  border-radius: 5px;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 0;
}
</style>
